var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar"},[_c('div',{style:(_vm.currentWidth)},[(_vm.showText)?_c('span',{style:(_vm.textPosition)},[_vm._v(_vm._s(_vm.displayText))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }